import { sharedData } from '../../../models/shared_data'
import React from 'react'
import { LoginButton } from '../login_button.component'
import { superagent } from '../../shared/superagent/superagent';
import singletons from '../../shared/singletons'
import { Observable } from 'rxjs'
import { MessageComponent } from '../../shared/dialog/message.component'
import { CheckBoxComponent } from '../../shared/checkbox/checkbox.component'
import { SelectComponent } from '../../shared/select/select.component'

export class Settings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      client: sharedData.data.client,
      errors: {},
      updated: false
    }

    this.submit = this.submit.bind(this)
    this.onCloseMessage = this.onCloseMessage.bind(this)
    this.ur_types = [
      {id: 'simple', title: 'Упрощенка'},
      {id: 'common', title: 'Общая'}
    ]
  }

  isError(name) {
    if(this.state.errors[name])
      return ' error '
    return ''
  }

  isActive() {
    return ''
  }

  changed(name, e) {

    if(e.preventDefault)
      e.preventDefault()
    const v = e.target ? e.target.value : e

    this.setState((ps)=> {
      ps.client[name] = v
      return ps
    })
  }

  submit(e) {
    e.preventDefault()
    this.setState({
      errors: {}
    })

    this.update(this.state.client)
      .subscribe((data)=> {
        if(data.status == 'errors') {
          this.setState({errors: data.errors})
          return
        }

        this.setState({
          updated: true
        })
      })
  }

  update(client) {
    return Observable.create((obs)=> {
      singletons['loading'].start()
      superagent.put("/api/settings")
        .send({client: client})
        .end((err, resp)=> {
          const data = resp.body
          singletons['loading'].stop()
          obs.next(data)
          obs.complete()
        })
    })
  }

  onCloseMessage() {
    this.setState({
      updated: false
    })
  }

  changedClientType(e) {
    if(e) {
      this.changed('client_type', 'ur')
    } else {
      this.changed('client_type', 'fiz')
    }
  }

  render() {
    const s = this.state
    const prms = {
      message: 'Настройки обновлены'
    }
    return (
      <div>
        { s.updated &&
          <MessageComponent
            params={prms}
            timeout={3}
            onClose={this.onCloseMessage}
          />
        }
        <form onSubmit={this.submit}>
          <div className="input-white">
            <input
              className={ "input__text " +
                this.isError('fio')
              }
              placeholder="ФИО"
              type="text"
              value={s.client.fio}
              onChange={(e)=> { this.changed('fio', e) }}
            />
          </div>

          <div className="input-white">
            <input
              className={ "input__text " +
                this.isError('email')
              }
              placeholder="email"
              type="email"
              value={s.client.email}
              onChange={(e)=> { this.changed('email', e) }}
            />
          </div>

          <div>
            <CheckBoxComponent
              title="Юр лицо"
              value={s.client.client_type == 'ur'}
              onChange={(v)=> {this.changedClientType(v)}}
              cl="mb-10 checkbox--gray-bg"
            />
          </div>

          { s.client.client_type == 'ur' &&
            <div>
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="input-white">
                    <input
                      className={ "input__text " +
                        this.isError('ur_title')
                      }
                      placeholder="Официальное название компании"
                      type="text"
                      value={s.client.ur_title}
                      onChange={(e)=> { this.changed('ur_title', e) }}
                    />
                  </div>
                  <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_address')
                    }
                    placeholder="Адрес фактичекский"
                    type="text"
                    value={s.client.ur_address}
                    onChange={(e)=> { this.changed('ur_address', e) }}
                  />
                  </div>
                  <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_off_address')
                    }
                    placeholder="Адрес юридический"
                    type="text"
                    value={s.client.ur_off_address}
                    onChange={(e)=> { this.changed('ur_off_address', e) }}
                  />
                  </div>
                  <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_bank_title')
                    }
                    placeholder="Название банка"
                    type="text"
                    value={s.client.ur_bank_title}
                    onChange={(e)=> { this.changed('ur_bank_title', e) }}
                  />
                  </div>
                  <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_bank_bik')
                    }
                    placeholder="БИК банка"
                    type="text"
                    value={s.client.ur_bank_bik}
                    onChange={(e)=> { this.changed('ur_bank_bik', e) }}
                  />
                  </div>
                  <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_account_number')
                    }
                    placeholder="Номер расчетного счета"
                    type="text"
                    value={s.client.ur_account_number}
                    onChange={(e)=> { this.changed('ur_account_number', e) }}
                  />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6">

                <div className="input-white">

                <input
                  className={ "input__text " +
                    this.isError('ur_kor_account')
                  }
                  placeholder="Кор счет"
                  type="text"
                  value={s.client.ur_kor_account}
                  onChange={(e)=> { this.changed('ur_kor_account', e) }}
                />
                </div>
                <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_inn')
                    }
                    placeholder="ИНН"
                    type="text"
                    value={s.client.ur_inn}
                    onChange={(e)=> { this.changed('ur_inn', e) }}
                  />
                  </div>
                  <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_ogrn_ip')
                    }
                    placeholder="ОГРН/ОГРИП"
                    type="text"
                    value={s.client.ur_ogrn_ip}
                    onChange={(e)=> { this.changed('ur_ogrn_ip', e) }}
                  />
                  </div>
                  <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_phone')
                    }
                    placeholder="Юр телефон"
                    type="text"
                    value={s.client.ur_phone}
                    onChange={(e)=> { this.changed('ur_phone', e) }}
                  />
                  </div>
                  <div className="input-white">

                  <input
                    className={ "input__text " +
                      this.isError('ur_email')
                    }
                    placeholder="Юр email"
                    type="text"
                    value={s.client.ur_email}
                    onChange={(e)=> { this.changed('ur_email', e) }}
                  />
                  </div>
                  {/*
                  <SelectComponent
                    opts={this.ur_types}
                    value={s.client.ur_acccount_type}
                    onChange={ (e)=> { this.changed('ur_acccount_type', e) } }
                  />
                  */}

                </div>
              </div>
            </div>
          }

          <button className="btn mb-10">Сохранить</button>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/settings/settings.component.jsx